import React from "react";
import classes from "./CancelPopUp.module.css";
import rocketImage from "../../public/studioErstellen/rocketImage.webp"
import coinImage from "../../public/studioErstellen/coinImage.webp"
import percentageImage from "../../public/studioErstellen/percentageImage.webp"
import { SmallModal } from "../UI/SmallModal/SmallModal";

export const CancelPopUp = ({ showExitModal, cancelExit, confirmExit, fromServiceCreation }) => {
  return (
    <div className={classes.container}>
       <SmallModal 
            open={showExitModal} 
            onBackdropClick={cancelExit}
            fromDeleteStudio={true}
        >
            <div className={classes.exitModalContainer}>
                <header className={classes.exitModalHeader}>
                    <h2 className={`${classes.exitModalTitle} titleSemibold3`}>
                        {fromServiceCreation ? "Service-Erstellung beenden?" : "Studio-Erstellung beenden?"}
                    </h2>
                    <button onClick={cancelExit} className={classes.exitModalCloseButton}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M7.50947 9L0 1.49054L0.990535 0.5L8.5 8.00947L16.0095 0.5L17 1.49054L9.49054 9L17 16.5095L16.0095 17.5L8.5 9.99054L0.990535 17.5L0 16.5095L7.50947 9Z" fill="#1F1F1F"/>
                        </svg>
                    </button>
                </header>
                <p className={`${classes.exitModalText} regularLarge`}>
                    Wenn du den Prozess beendest, geht dein Fortschritt verloren.
                </p>
                <div className={classes.mainSuccessModal}>
                  <div className={classes.successModalItem}>
                    <div className={classes.successModalItemImage}>
                      <img src={rocketImage} alt="Mehr Sichtbarkeit" />
                    </div>
                    <h4 className="semiboldXs">Mehr Sichtbarkeit</h4>
                  </div>
                  <div className={classes.successModalItem}>
                    <div className={classes.successModalItemImage}>
                      <img src={coinImage} alt="Ein exklusives Badge" />
                    </div>
                    <h4 className="semiboldXs">Ein exklusives Badge</h4>
                  </div>
                  <div className={classes.successModalItem}>
                    <div className={classes.successModalItemImage}>
                      <img src={percentageImage} alt="Reduzierte Gebühren" />
                    </div>
                    <h4 className="semiboldXs">Reduzierte Gebühren</h4>
                  </div>
                </div>
                <div className={classes.exitModalButtonsContainer}>
                    <button 
                        onClick={confirmExit}
                        className={`${classes.exitModalCancelButton} mediumLarge`}
                    >
                        Prozess beenden
                    </button>
                    <button 
                        onClick={cancelExit}
                        className={`${classes.exitModalYesButton} mediumLarge`}
                    >
                        Zurück
                    </button>
                </div>
            </div>
        </SmallModal>
    </div>
  );
};

export default CancelPopUp;